import { gql } from '@apollo/client';

export default gql`
  mutation createSalaryPayment(
    $_id: String
    $time: Date
    $title: String
    $desc: String
    $debitAcc: Int
    $creditAcc: Int
    $amount: Float
    $links: [String]
    $attachments: String
  ) {
    createSalaryPayment(
      _id: $_id
      time: $time
      title: $title
      desc: $desc
      debitAcc: $debitAcc
      creditAcc: $creditAcc
      amount: $amount
      links: $links
      attachments: $attachments
    ) {
      ok
      message
      data
      error
    }
  }
`;
